import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconWrenchGradient = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={26}
    fill="none"
    viewBox="0 0 34 26"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-wrench-gradient_svg__a)">
      <path
        fill="#fff"
        fillOpacity={0.95}
        d="M24.844 7.844c.187.75.187 1.562-.063 2.406-.468 1.938-2.093 3.406-4.031 3.719a4.635 4.635 0 0 1-2.375-.188l-5.563 5.563c-.468.437-1.062.656-1.593.656a2.002 2.002 0 0 1-1.531-.688 2.172 2.172 0 0 1 0-3.156l5.562-5.562c-.25-.75-.344-1.563-.156-2.375.281-1.938 1.781-3.563 3.719-4.031a5.082 5.082 0 0 1 2.375 0c.375.093.5.562.218.843L19 7.406v2.625h2.625L24 7.625a.5.5 0 0 1 .844.219ZM11.5 18.25a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75.74.74 0 0 0-.75.75c0 .438.313.75.75.75Z"
      />
    </g>
    <defs>
      <filter
        id="icon-wrench-gradient_svg__a"
        width={32.25}
        height={32}
        x={0.781}
        y={-2}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5353"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5353"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5353"
          result="effect2_dropShadow_6025_5353"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5353"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconWrenchGradient;
